var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDownActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z",
    fill: "#EAFAF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1665 9.66667V18.8333M26.3332 16.1667V12.3333C26.3332 11.3999 26.3332 10.9332 26.1516 10.5767C25.9918 10.2631 25.7368 10.0081 25.4232 9.84833C25.0667 9.66667 24.6 9.66667 23.6665 9.66667H14.7649C13.547 9.66667 12.938 9.66667 12.4462 9.88953C12.0127 10.086 11.6443 10.402 11.3842 10.8006C11.0892 11.2528 10.9966 11.8547 10.8114 13.0584L10.3755 15.8918C10.1313 17.4794 10.0091 18.2733 10.2447 18.8909C10.4515 19.4331 10.8404 19.8864 11.3448 20.1732C11.9195 20.5 12.7227 20.5 14.329 20.5H14.9999C15.4666 20.5 15.6999 20.5 15.8782 20.5908C16.035 20.6707 16.1625 20.7982 16.2424 20.955C16.3332 21.1333 16.3332 21.3666 16.3332 21.8333V24.2785C16.3332 25.4133 17.2532 26.3333 18.3881 26.3333C18.6588 26.3333 18.9041 26.1739 19.014 25.9266L21.8146 19.6252C21.942 19.3385 22.0057 19.1952 22.1064 19.0902C22.1954 18.9973 22.3047 18.9263 22.4257 18.8827C22.5626 18.8333 22.7194 18.8333 23.033 18.8333H23.6665C24.6 18.8333 25.0667 18.8333 25.4232 18.6517C25.7368 18.4919 25.9918 18.2369 26.1516 17.9233C26.3332 17.5668 26.3332 17.1001 26.3332 16.1667Z",
    stroke: "#1F7A50",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownActive);
export default __webpack_public_path__ + "static/media/thumbsDownActive.eed895427b6cb99012ce9c936c9158a4.svg";
export { ForwardRef as ReactComponent };